import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StructureUserRolesComponent } from './structure-user-roles/structure-user-roles.component';
import { UserComponent } from './user/user.component';
import { SharedModule } from '../../core/shared/shared.module';
import { StructureUsersComponent } from './structure-users/structure-users.component';
import { StructureUsersRootComponent } from './structure-users-root/structure-users-root.component';
import { structureUsersRootRouting } from './structure-users-root/structure-users-root.routing';
import { UsersRest } from './structure-users.rest';

@NgModule({
  imports: [
    CommonModule,
    structureUsersRootRouting,
    SharedModule
  ],
  exports:[],
  declarations: [StructureUserRolesComponent, UserComponent, StructureUsersComponent, StructureUsersRootComponent],
  providers: [UsersRest]
})
export class StructureUsersModule { }
